import type { Translations } from './en.js';

const ptBR: Translations = {
  ok: 'OK', cancel: 'Cancelar', close: 'Fechar', confirm: 'Confirmar', retry: 'Tentar novamente', back: 'Voltar', settings: 'Configuracoes', language: 'Idioma',
  score: 'Pontuacao', level: 'Nivel', game_over: 'Fim de jogo', restart: 'Reiniciar', pause: 'Pausado', resume: 'Continuar',
  settings_sound: 'Som', settings_music: 'Musica', settings_reset: 'Reiniciar jogo', settings_reset_confirm: 'Reiniciar todo o progresso?',
  ad_watch: 'Ver anuncio', ad_reward: 'Recompensa gratis', ad_loading: 'Carregando anuncio...', ad_reward_received: 'Recompensa recebida!', ad_not_completed: 'Anuncio nao concluido',
  offline_title: 'Bem-vindo de volta!', offline_earned: 'Ganho enquanto estava fora',
  sp: 'SP', fame: 'Fama', building_tab: 'Edificio', ghosts_tab: 'Fantasmas', shop_tab: 'Loja', prestige_tab: 'Prestigio',
  training_tab: 'Treinamento', facilities_tab: 'Extras', reviews_tab: 'Avaliacoes',
  floor_label: 'Andar {n}', buy_floor: 'Comprar andar', buy_floor_cost: 'Comprar andar ({sp} SP)', unlock_slot: 'Desbloquear slot', unlock_slot_cost: 'Desbloquear slot ({sp} SP)',
  build_room: 'Construir sala', upgrade_room: 'Melhorar sala', upgrade_room_cost: 'Melhorar ({sp} SP)', room_empty: 'Vazio', room_locked: 'Bloqueado',
  no_ghost: 'Sem fantasma', assign_ghost: 'Designar fantasma', visitors_floor: 'Visitantes neste andar',
  add_floor: 'Adicionar andar', add_floor_cost: '+ Novo andar ({sp} SP)', menu_tab: 'Menu',
  room_dark_corridor: 'Corredor escuro', room_dark_corridor_desc: 'Medo psicologico +30%',
  room_mirror_room: 'Sala dos espelhos', room_mirror_room_desc: 'Visual +25%, Psicologico +15%',
  room_dungeon: 'Masmorra', room_dungeon_desc: 'Psicologico +20%, Fisico +20%',
  room_graveyard: 'Sala do cemiterio', room_graveyard_desc: 'Medo psicologico +40%',
  room_lab: 'Laboratorio', room_lab_desc: 'Visual +30%, Fisico +20%',
  room_library: 'Biblioteca', room_library_desc: 'Psicologico +35%, Auditivo +15%',
  room_coffin_room: 'Sala do caixao', room_coffin_room_desc: 'Visual +30%, Psicologico +20%',
  room_doll_room: 'Sala das bonecas', room_doll_room_desc: 'Visual +20%, Psicologico +35%',
  room_kitchen: 'Cozinha amaldicoada', room_kitchen_desc: 'Fisico +30%, Auditivo +20%',
  room_bathroom: 'Banheiro assombrado', room_bathroom_desc: 'Psicologico +30%, Auditivo +25%',
  room_funhouse: 'Casa dos Espelhos',
  room_funhouse_desc: 'Visual+35%, Psicológico+20%',
  room_trapeze_room: 'Sala do Trapézio',
  room_trapeze_room_desc: 'Físico+30%, Visual+15%',
  room_freak_show: 'Show de Aberrações',
  room_freak_show_desc: 'Visual+40%, Psicológico+30%',
  room_sacrifice_altar: 'Altar de Sacrifício',
  room_sacrifice_altar_desc: 'Psicológico+40%, Visual+20%',
  room_treasure_vault: 'Cofre do Tesouro',
  room_treasure_vault_desc: 'Psicológico+20%, Auditivo+20%',
  room_underground_river: 'Rio Subterrâneo',
  room_underground_river_desc: 'Auditivo+30%, Psicológico+20%',
  room_curse_chamber: 'Câmara da Maldição',
  room_curse_chamber_desc: 'Psicológico+45%, Físico+15%',
  room_mummy_tomb: 'Tumba da Múmia',
  room_mummy_tomb_desc: 'Visual+30%, Psicológico+30%',
  room_captain_cabin: 'Cabine do Capitão',
  room_captain_cabin_desc: 'Psicológico+30%, Visual+20%',
  room_cargo_hold: 'Porão de Carga',
  room_cargo_hold_desc: 'Físico+25%, Auditivo+20%',
  room_davy_jones_locker: 'Cofre de Davy Jones',
  room_davy_jones_locker_desc: 'Psicológico+35%, Visual+25%',
  room_brig: 'Calabouço do Navio',
  room_brig_desc: 'Físico+30%, Psicológico+20%',
  room_crows_nest: 'Ninho do Corvo',
  room_crows_nest_desc: 'Físico+35%, Visual+20%',
  room_mine_shaft: 'Poço da Mina',
  room_mine_shaft_desc: 'Físico+30%, Auditivo+20%',
  room_crystal_cave: 'Caverna de Cristal',
  room_crystal_cave_desc: 'Visual+35%, Auditivo+15%',
  room_explosives_storage: 'Depósito de Explosivos',
  room_explosives_storage_desc: 'Físico+40%, Auditivo+25%',
  room_underground_lake: 'Lago Subterrâneo',
  room_underground_lake_desc: 'Psicológico+30%, Auditivo+25%',
  room_rail_tunnel: 'Túnel do Trem',
  room_rail_tunnel_desc: 'Físico+30%, Psicológico+20%',
  room_throne_room: 'Salão do Trono',
  room_throne_room_desc: 'Visual+25%, Psicológico+30%',
  room_wine_cellar: 'Adega de Vinhos',
  room_wine_cellar_desc: 'Psicológico+30%, Visual+15%',
  room_tower_chamber: 'Câmara da Torre',
  room_tower_chamber_desc: 'Psicológico+35%, Físico+20%',
  room_server_room: 'Sala de Servidores',
  room_server_room_desc: 'Auditivo+30%, Visual+20%',
  room_quarantine_zone: 'Zona de Quarentena',
  room_quarantine_zone_desc: 'Psicológico+35%, Físico+20%',
  room_armory: 'Arsenal',
  room_armory_desc: 'Físico+35%, Visual+20%',
  room_witch_hut: 'Cabana da Bruxa',
  room_witch_hut_desc: 'Visual+30%, Psicológico+25%',
  room_treehouse: 'Casa na Árvore',
  room_treehouse_desc: 'Físico+25%, Auditivo+20%',
  room_swamp_path: 'Trilha do Pântano',
  room_swamp_path_desc: 'Psicológico+30%, Auditivo+20%',
  room_fairy_ring: 'Círculo de Fadas',
  room_fairy_ring_desc: 'Psicológico+40%, Visual+20%',
  room_ancient_ruin: 'Ruínas Antigas',
  room_ancient_ruin_desc: 'Psicológico+35%, Visual+25%',
  room_attic: 'Sótão',
  room_attic_desc: 'Psicológico+30%, Auditivo+15%',
  room_secret_passage: 'Passagem Secreta',
  room_secret_passage_desc: 'Psicológico+35%, Físico+15%',
  room_morgue: 'Necrotério',
  room_morgue_desc: 'Visual+30%, Psicológico+30%',
  room_surgery_room: 'Centro Cirúrgico',
  room_surgery_room_desc: 'Físico+35%, Visual+25%',
  room_music_room: 'Sala de Música',
  room_music_room_desc: 'Auditivo+40%, Psicológico+20%',
  room_science_lab: 'Laboratório de Ciências',
  room_science_lab_desc: 'Visual+30%, Físico+25%',
  room_ticket_booth: 'Bilheteria',
  room_ticket_booth_desc: 'Psico+25%, Visual+20%',
  room_animal_cage: 'Jaula de Animais',
  room_animal_cage_desc: 'Fisico+30%, Visual+25%',
  room_clown_tent: 'Tenda do Palhaco',
  room_clown_tent_desc: 'Psico+40%, Visual+20%',
  room_hall_of_mirrors: 'Sala dos Espelhos',
  room_hall_of_mirrors_desc: 'Visual+40%, Psico+30%',
  room_elevator_shaft: 'Poco do Elevador',
  room_elevator_shaft_desc: 'Fisico+35%, Psico+20%',
  room_ore_processing: 'Processamento de Minerio',
  room_ore_processing_desc: 'Auditivo+30%, Fisico+20%',
  room_collapsed_tunnel: 'Tunel Desmoronado',
  room_collapsed_tunnel_desc: 'Fisico+40%, Psico+25%',
  room_miners_quarters: 'Alojamento dos Mineiros',
  room_miners_quarters_desc: 'Psico+30%, Visual+20%',
  room_command_center: 'Centro de Comando',
  room_command_center_desc: 'Psico+30%, Auditivo+25%',
  room_ventilation_shaft: 'Duto de Ventilacao',
  room_ventilation_shaft_desc: 'Fisico+35%, Auditivo+25%',
  room_decontamination: 'Descontaminacao',
  room_decontamination_desc: 'Psico+35%, Visual+25%',
  room_hollow_tree: 'Arvore Oca',
  room_hollow_tree_desc: 'Visual+30%, Psico+25%',
  room_spider_nest: 'Ninho de Aranhas',
  room_spider_nest_desc: 'Visual+35%, Fisico+25%',
  room_moonlit_clearing: 'Clareira ao Luar',
  room_moonlit_clearing_desc: 'Psico+40%, Auditivo+20%',
  room_abandoned_cabin: 'Cabana Abandonada',
  room_abandoned_cabin_desc: 'Psico+30%, Visual+20%',

  room_ward_room: 'Enfermaria',
  room_ward_room_desc: 'Psico+30%, Visual+20%',
  room_reception_hall: 'Recepcao',
  room_reception_hall_desc: 'Psico+25%, Audit+20%',
  room_x_ray_room: 'Sala de Raio-X',
  room_x_ray_room_desc: 'Visual+35%, Fisico+20%',
  room_classroom: 'Sala de Aula',
  room_classroom_desc: 'Psico+30%, Audit+15%',
  room_art_room: 'Sala de Arte',
  room_art_room_desc: 'Visual+35%, Psico+20%',
  room_gymnasium: 'Ginasio',
  room_gymnasium_desc: 'Fisico+30%, Audit+25%',
  room_rooftop: 'Telhado',
  room_rooftop_desc: 'Psico+40%, Fisico+20%',
  room_crypt: 'Cripta',
  room_crypt_desc: 'Visual+35%, Psico+25%',
  room_powder_room: 'Paiol',
  room_powder_room_desc: 'Fisico+40%, Audit+20%',
  room_navigation_room: 'Sala de Navegacao',
  room_navigation_room_desc: 'Psico+30%, Visual+20%',
  room_banquet_hall: 'Salao de Banquete',
  room_banquet_hall_desc: 'Psico+30%, Visual+20%',
  room_chapel: 'Capela',
  room_chapel_desc: 'Psico+40%, Audit+20%',
  room_torture_chamber: 'Camara de Tortura',
  room_torture_chamber_desc: 'Fisico+40%, Visual+30%',
  room_armory_hall: 'Sala de Armas',
  room_armory_hall_desc: 'Fisico+30%, Visual+25%',
  room_science_room: 'Laboratorio',
  room_science_room_desc: 'Visual+30%, Psico+20%',

  unlock_requires_day: 'Dia {n}+',
  unlock_requires_fame: 'Fama {n}+',
  unlock_requires_room: 'Requer: {name}',
  unlock_condition_not_met: 'Condições não atendidas',
  room_repair_needed: 'Precisa de reparo', room_repairing: 'Em reparo', room_cleaning: 'Em limpeza',
  ghost_roster: 'Lista de fantasmas', ghost_idle: 'Inativo', ghost_assigned: 'Designado', ghost_fatigue: 'Fadiga',
  ghost_level: 'Nv.{n}', ghost_exp: 'EXP {cur}/{max}', ghost_level_up: 'Subir nivel',
  recover_fatigue: 'Recuperar fadiga ({sp} SP)', ghost_fatigued_warning: 'Exausto! Eficiencia -50%', unassign_ghost: 'Remover designacao',
  ghost_training_in_progress: 'Treinando...',
  shop_ghosts: 'Contratar fantasmas', shop_rooms: 'Tipos de sala', hire: 'Contratar', hire_cost: '{sp} SP', already_hired: 'Contratado',
  not_enough_sp: 'SP insuficiente!', unlock_room_type: 'Desbloquear', unlock_cost: '{sp} SP', already_unlocked: 'Desbloqueado',
  grade_c: 'Grau C', grade_b: 'Grau B', grade_a: 'Grau A', grade_s: 'Grau S',
  ghost_jinaeryeong: 'Fantasma coreana', ghost_gangsi: 'Jiangshi', ghost_vampire: 'Vampiro', ghost_kappa: 'Kappa', ghost_pierrot: 'Palhaco', ghost_banshee: 'Banshee',
  ghost_origin_korea: 'Coreia', ghost_origin_china: 'China', ghost_origin_romania: 'Romania', ghost_origin_japan: 'Japao', ghost_origin_usa: 'EUA', ghost_origin_ireland: 'Irlanda',
  ghost_jinaeryeong_skill: 'Queda de cabelo: cai do teto com medo fisico extra',
  ghost_gangsi_skill: 'Salto rigido: pula rigidamente assustando 2 visitantes',
  ghost_vampire_skill: 'Olhos hipnoticos: congela 1 visitante por 10s, proxima sala +30%',
  ghost_kappa_skill: 'Giro do prato: gira o prato da cabeca para medo visual',
  ghost_pierrot_skill: 'Ataque de risada: aparicao repentina, medo de palhaco',
  ghost_banshee_skill: 'Grito: maximo medo auditivo, pode ativar varias vezes',
  ghost_jinaeryeong_quote: 'Assustei 10 visitantes hoje, chefe!', ghost_gangsi_quote: 'Pular e muito dificil...',
  ghost_vampire_quote: 'A noite e longa e eu sou eterno.', ghost_kappa_quote: 'Nao derrame a agua!',
  ghost_pierrot_quote: 'Por que tao serio?', ghost_banshee_quote: 'Minha garganta doi de tanto gritar.',
  ghost_jinaeryeong_fatigued: 'Chefe... meu cabelo esta por todo lado. Preciso descansar!',
  ghost_gangsi_fatigued: 'Nao consigo mais me mover... literalmente.', ghost_vampire_fatigued: 'Ate os imortais precisam de descanso...',
  ghost_kappa_fatigued: 'Meu prato secou, preciso de agua!', ghost_pierrot_fatigued: 'Nao consigo mais rir, chefe.',
  ghost_banshee_fatigued: 'Minha voz sumiu! Nao consigo gritar!',
  room_unlock_in_shop: 'Desbloquear na loja',
  visitor_scaredy_kid: 'Crianca covarde', visitor_scaredy_kid_desc: 'Assusta facil mas satisfeito com pouco',
  visitor_normal: 'Visitante', visitor_normal_desc: 'Tolerancia ao medo media',
  visitor_brave: 'Corajoso', visitor_brave_desc: 'Alta tolerancia, grande recompensa ao satisfazer',
  visitor_couple: 'Casal', visitor_couple_desc: 'Medo moderado, alta recompensa, boas avaliacoes',
  visitor_youtuber: 'Youtuber', visitor_youtuber_desc: 'Avaliacoes com 2.5x influencia na fama',
  visitor_exorcist: 'Exorcista', visitor_exorcist_desc: 'Quase impossivel de assustar, recompensa enorme',
  visitor_thrill_seeker: 'Buscador de emocoes', visitor_thrill_seeker_desc: 'Quer sustos intensos, impaciente com fracos',
  visitor_coward: 'Covarde', visitor_coward_desc: 'Aterrorizado com tudo, foge facilmente',
  time_phase_day: 'Dia', time_phase_evening: 'Tarde', time_phase_night: 'Noite', time_phase_rain: 'Chuva',
  reputation_label: 'Rep: {n}',
  scare_chain: 'Cadeia x{n}!', terror_max: 'TERROR MAXIMO!', sp_earned: '+{sp} SP',
  prestige_title: 'Expansao de franquia', prestige_desc: 'Sua casa assombrada e famosa no mundo! Abrir uma franquia?',
  prestige_requirement_floors: '{n} andares necessarios', prestige_requirement_fame: 'Fama {n} necessaria',
  prestige_requirement_sp: 'SP total {n} necessario', prestige_not_ready: 'Requisitos nao cumpridos',
  prestige_confirm: 'Abrir franquia', prestige_level: 'Prestigio Nv.{n}',
  prestige_bonus: 'Todos os fantasmas +{n}% medo, +{sp} SP inicial', offline_collect: 'Coletar',

  training_title: 'Aula de atuacao', training_select: 'Escolher treinamento', training_cost: '{sp} SP', training_duration: '{sec}s',
  training_in_progress: 'Treinando...', training_complete: 'Treinamento concluido!', training_bonus: 'Medo +{pct}%',
  training_skip_ad: 'Pular (Anuncio)', training_count: '{n} sessoes concluidas', training_ghost_busy: 'Primeiro remova a designacao', training_already: 'Ja treinando',
  training_scream_practice: 'Pratica de gritos', training_scream_practice_desc: 'Melhorar projecao vocal e timing',
  training_jumpscare_acting: 'Atuacao de susto', training_jumpscare_acting_desc: 'Dominar a arte da aparicao repentina',
  training_psychological_acting: 'Horror psicologico', training_psychological_acting_desc: 'Aprender a criar terror persistente',
  training_atmosphere_directing: 'Direcao de atmosfera', training_atmosphere_directing_desc: 'Controlar luzes, som e nevoa',
  training_physical_training: 'Treinamento fisico', training_physical_training_desc: 'Desenvolver resistencia para sustos energeticos',
  training_audience_analysis: 'Analise de audiencia', training_audience_analysis_desc: 'Estudar comportamento de visitantes',

  tq_jinaeryeong_scream: 'Fantasma coreana analisando filmes de terror no YouTube...',
  tq_gangsi_scream: 'Jiangshi praticando gritos em posicao rigida...',
  tq_vampire_scream: 'Vampiro cantarolando opera no porao...',
  tq_kappa_scream: 'Kappa gorgolando gritos subaquaticos em um balde...',
  tq_pierrot_scream: 'Palhaco gritando em um balao...', tq_banshee_scream: 'Banshee dando masterclass para iniciantes...',
  tq_jinaeryeong_jumpscare: 'Fantasma coreana pulando repetidamente de armarios...',
  tq_gangsi_jumpscare: 'Jiangshi alongando antes de praticar saltos...',
  tq_vampire_jumpscare: 'Vampiro praticando revelacoes dramaticas de capa...',
  tq_kappa_jumpscare: 'Kappa surgindo de vasos sanitarios...', tq_pierrot_jumpscare: 'Palhaco ensaiando o timing do estouro do balao...',
  tq_banshee_jumpscare: 'Banshee trabalhando na coreografia de entrada...',
  tq_jinaeryeong_psych: 'Fantasma coreana estudando livros de psicologia...',
  tq_gangsi_psych: 'Jiangshi tentando parecer assustador (ja e)...',
  tq_vampire_psych: 'Vampiro praticando na frente do espelho... (nao reflete)',
  tq_kappa_psych: 'Kappa aprendendo sobre medos humanos na biblioteca...',
  tq_pierrot_psych: 'Palhaco assistindo "It" pela 50a vez...', tq_banshee_psych: 'Banshee escrevendo roteiros de sussurros arrepiantes...',
  tq_jinaeryeong_atmo: 'Fantasma coreana arrumando o cabelo para maximo efeito...',
  tq_gangsi_atmo: 'Jiangshi ajustando a maquina de nevoa...',
  tq_vampire_atmo: 'Vampiro escolhendo o angulo perfeito de vela...',
  tq_kappa_atmo: 'Kappa testando diferentes sons de gotas de agua...',
  tq_pierrot_atmo: 'Palhaco pintando paredes com tinta fluorescente...',
  tq_banshee_atmo: 'Banshee calibrando efeitos de eco no corredor...',
  tq_jinaeryeong_physical: 'Fantasma coreana fazendo exercicios de rastejamento no teto...',
  tq_gangsi_physical: 'Jiangshi fazendo agachamentos com pernas rigidas...',
  tq_vampire_physical: 'Vampiro fazendo flexoes no caixao...',
  tq_kappa_physical: 'Kappa nadando voltas no lago...',
  tq_pierrot_physical: 'Palhaco fazendo abdominais enquanto faz malabarismo...',
  tq_banshee_physical: 'Banshee aquecendo as cordas vocais...',
  tq_jinaeryeong_audience: 'Fantasma coreana lendo avaliacoes de visitantes online...',
  tq_gangsi_audience: 'Jiangshi estudando padroes de fluxo de visitantes...',
  tq_vampire_audience: 'Vampiro analisando demografias do medo...',
  tq_kappa_audience: 'Kappa pesquisando quais idades temem agua...',
  tq_pierrot_audience: 'Palhaco rastreando estatisticas de coulrofobia...',
  tq_banshee_audience: 'Banshee estudando respostas de medo a frequencias sonoras...',

  props_title: 'Decoracoes de sala', prop_buy: 'Comprar ({sp} SP)', prop_upgrade: 'Melhorar ({sp} SP)', prop_max: 'MAX', prop_level: 'Nv.{n}', prop_bonus: '+{pct}% medo',
  prop_cobwebs: 'Teias de aranha', prop_cobwebs_desc: 'Atmosfera classica assustadora',
  prop_candles: 'Velas tremulantes', prop_candles_desc: 'Sombras dancantes sinistras',
  prop_blood_pool: 'Poca de sangue', prop_blood_pool_desc: 'Decoracao de piso horrivel',
  prop_skull_decor: 'Decoracao de caveira', prop_skull_decor_desc: 'Exibicao arrepiante',
  prop_fog_machine: 'Maquina de nevoa', prop_fog_machine_desc: 'Nevoa espessa e misteriosa',
  prop_creaky_floor: 'Tabuas rangentes', prop_creaky_floor_desc: 'Cada passo faz barulho',
  prop_eerie_painting: 'Pintura sinistra', prop_eerie_painting_desc: 'Olhos que seguem voce',
  prop_chains: 'Correntes barulhentas', prop_chains_desc: 'Sons metalicos assustadores',

  // Staging Equipment
  prop_dry_ice: 'Maquina de gelo seco', prop_dry_ice_desc: 'Cria nevoa densa para atmosfera aterrorizante',
  prop_scent_sprayer: 'Borrifador de aromas', prop_scent_sprayer_desc: 'Cheiros perturbadores para imersao total',
  prop_strobe_light: 'Luz estroboscopica', prop_strobe_light_desc: 'Flashes que desorientam os visitantes',
  prop_surround_speaker: 'Alto-falante surround', prop_surround_speaker_desc: 'Audio espacial para efeitos aterrorizantes',
  prop_vibration_floor: 'Painel de vibracao', prop_vibration_floor_desc: 'Tremores repentinos sob os pes',
  prop_temp_controller: 'Controlador de temperatura', prop_temp_controller_desc: 'Rajadas de ar frio para terror psicologico',
  prop_hologram_device: 'Dispositivo holografico', prop_hologram_device_desc: 'Projeta aparicoes fantasmagoricas',
  prop_auto_lock: 'Fechadura automatica', prop_auto_lock_desc: 'Portas se trancam inesperadamente',
  props_category_decoration: 'Decoracoes', props_category_staging: 'Equipamento de cenografia',
  props_staging_desc: 'Equipamento avancado para efeitos de terror profissional',

  facilities_title: 'Instalacoes auxiliares', facility_build: 'Construir ({sp} SP)', facility_upgrade: 'Melhorar ({sp} SP)',
  facility_level: 'Nv.{n}', facility_built: 'Construido',
  facility_haunted_house: 'Casa Assombrada', facility_haunted_house_desc: 'Predio principal de experiencia de terror',
  facility_haunted_house_bonus: 'Entrada do predio principal', facility_enter: 'Entrar',
  facility_ticket_booth: 'Bilheteria', facility_ticket_booth_desc: 'Vende ingressos para os visitantes', facility_ticket_booth_bonus: 'Aumenta a capacidade máxima de visitantes', facility_ticket_booth_visitors: 'visitantes',
  facility_gift_shop: 'Loja de presentes', facility_gift_shop_desc: 'Vende souvenirs da casa assombrada',
  facility_gift_shop_bonus: '+{sp} SP por grupo de visitantes',
  facility_snack_bar: 'Lanchonete', facility_snack_bar_desc: 'Lanches e bebidas assustadores',
  facility_snack_bar_bonus: '+{pct}% recompensa de visitantes',
  facility_photo_booth: 'Cabine de fotos', facility_photo_booth_desc: 'Estacao de selfies de terror',
  facility_photo_booth_bonus: '+{sp} SP por grupo de visitantes',

  reviews_title: 'Avaliacoes de visitantes', reviews_empty: 'Ainda nao ha avaliacoes. Espere os visitantes!',
  reviews_fame_bonus: '+{n} Fama', review_stars: '{n} estrelas', reviews_avg: 'Media: {n} estrelas',
  review_5_1: 'Realmente assustador! {ghost} no andar 3 foi demais!',
  review_5_2: 'Melhor casa assombrada! Gritei tanto que perdi a voz!',
  review_5_3: 'A atuacao de {ghost} merecia um Oscar! 10/10!',
  review_5_4: 'Minha alma quase saiu do corpo. Vale cada centavo!',
  review_4_1: '{ghost} foi bem assustador, mas esperava mais dos andares superiores.',
  review_4_2: 'Otima atmosfera! Quase me borrei. Quase.',
  review_4_3: '{ghost} foi impressionante mas o timing poderia melhorar.',
  review_4_4: 'Sustos solidos. Recomendaria!',
  review_3_1: 'Foi ok. Algumas salas vazias estragaram o clima.',
  review_3_2: '{ghost} parecia cansado hoje. Descanse um pouco?',
  review_3_3: 'Experiencia media. Precisa de mais decoracoes.',
  review_2_1: '{ghost} estava dormindo no trabalho. Reembolso por favor.',
  review_2_2: 'Mais engracado do que assustador. Os fantasmas precisam de aulas de atuacao.',
  review_2_3: '{ghost} se esforcou mas... nao foi assustador.',
  review_1_1: 'Salas vazias por todo lado. Isso ta aberto?',
  review_1_2: 'Quero meu dinheiro de volta. Minha avo assusta mais.',
  review_1_3: '{ghost} acenou pra mim. ACENOU. Nao e assim que assombrar funciona.',

  review_street_5star: 'O parque inteiro e incrivel! A casa assombrada foi aterrorizante!', review_street_4star: 'Boa experiencia. Casa assombrada assustadora e lanches gostosos.', review_street_3star: 'Razoavel. A casa assombrada precisa de mais fantasmas.', review_street_2star: 'Nao tem muito o que fazer. Casa assombrada sem graca.', review_street_1star: 'Perda de tempo. Nada assustador.',

  review_vip_satisfied: 'VIP: Perfect! I will definitely come back with my friends.',
  review_vip_unsatisfied: 'VIP: Very disappointing experience. Not worth my time.',

  season_halloween: 'Halloween',
  season_summer_fest: 'Summer Fest',
  season_winter_chill: 'Winter Chill',
  season_spring_bloom: 'Spring Bloom',
  ad_sp_boost: 'SP x2 (30s)', ad_sp_boost_desc: 'Duplica todos os ganhos de SP por 30 segundos',
  ad_recover_fatigue: 'Recuperacao gratis', ad_recover_fatigue_desc: 'Recupera a fadiga do fantasma de graca',
  ad_vip_visitor: 'Visitantes VIP', ad_vip_visitor_desc: 'Invoca um grupo de visitantes de alta recompensa',
  ad_skip_training: 'Pular treinamento', ad_skip_training_desc: 'Completa o treinamento instantaneamente',
  ad_active_boost: 'SP x2 ativo!', ad_rewards_title: 'Recompensas de anuncios',

  // === Business / Open-Close System ===
  day_label: 'Dia {n}',
  hud_operation_day: 'Dia {n}',
  status_open: 'ABERTO',
  status_closed: 'FECHADO',
  manage_business: 'Manage Business',
  toggle_open: 'Abrir negocio',
  toggle_close: 'Fechar negocio',
  facility_open_badge: 'ABERTO',
  need_ghost_to_open: 'Atribua um fantasma a um quarto primeiro!',
  ticket_price: 'Preco do ingresso',
  ticket_price_label: '{n} SP',
  ticket_price_low: 'Mais visitantes, menos receita por visitante',
  ticket_price_high: 'Menos visitantes, mais receita por visitante',
  end_day: 'Encerrar dia',
  day_summary_title: 'RESUMO DO DIA {n}',
  day_summary_visitors: 'Visitantes: {n}',
  day_summary_earnings: 'Ganhos: {n} SP',
  day_summary_avg_rating: 'Avaliacao media: {n}',
  day_summary_next: 'ENCERRAR E COLETAR',
  day_summary_best_visitor: 'Visita {n} estrelas!',
  day_summary_sp_collected: 'SP TOTAL COLETADO',
  day_summary_sp_gain: '+{n}',
  day_summary_milestones: 'METAS DIARIAS',
  day_summary_total_visits: 'VISITAS TOTAIS',
  day_summary_reaction_5: 'ATERRORIZANTE!',
  day_summary_reaction_4: 'MUITO ASSUSTADOR!',
  day_summary_reaction_3: 'NAO E MAU',
  day_summary_reaction_2: 'MEH...',
  day_summary_reaction_1: 'CHATO...',

  milestone_visitors_5: 'Receber {target} visitantes',
  milestone_visitors_10: 'Receber {target} visitantes',
  milestone_visitors_20: 'Receber {target} visitantes',
  milestone_earnings_1000: 'Ganhar {target} SP',
  milestone_earnings_5000: 'Ganhar {target} SP',
  milestone_earnings_10000: 'Ganhar {target} SP',
  milestone_flee_0: 'Zero visitantes fugindo',
  milestone_flee_1: 'Maximo {target} visitante fugindo',
  milestone_rooms_3: 'Operar {target}+ salas',
  milestone_rooms_5: 'Operar {target}+ salas',
  milestone_ghosts_2: 'Implantar {target}+ fantasmas',
  milestone_ghosts_3: 'Implantar {target}+ fantasmas',
  milestone_reward: '+{n} SP',

  reviews_panel_title: 'AVALIACOES DOS VISITANTES',
  reviews_panel_avg: 'Avaliacao media',
  reviews_panel_empty: 'Nenhuma avaliacao ainda',

  // --- Missing keys (English fallback) ---
  ghost_mummy: 'Mummy',
  ghost_werewolf: 'Werewolf',
  ghost_origin_egypt: 'Egypt',
  ghost_origin_europe: 'Europe',
  ghost_mummy_skill: 'Bandage Wrap: Entangles visitors, physical + visual scare',
  ghost_werewolf_skill: 'Full Moon Howl: Terrifying transformation, max physical + auditory',
  ghost_mummy_quote: 'These bandages are so itchy...',
  ghost_werewolf_quote: 'Is there a full moon tonight? I feel... different.',
  ghost_mummy_fatigued: 'My bandages came undone... I tripped...',
  ghost_werewolf_fatigued: 'Even wolves need sleep... woof... zzz...',
  tq_mummy_scream: 'Mummy practicing muffled screams through bandages...',
  tq_werewolf_scream: 'Werewolf howling at a picture of the moon...',
  tq_mummy_jumpscare: 'Mummy bursting out of sarcophagus repeatedly...',
  tq_werewolf_jumpscare: 'Werewolf practicing surprise transformations...',
  tq_mummy_psych: 'Mummy reading ancient curse scrolls for inspiration...',
  tq_werewolf_psych: 'Werewolf studying pack hunting psychology...',
  tq_mummy_atmo: 'Mummy arranging ancient Egyptian artifacts for ambiance...',
  tq_werewolf_atmo: 'Werewolf setting up moonlight projectors...',
  tq_mummy_physical: 'Mummy doing stretches to prevent bandage tangles...',
  tq_werewolf_physical: 'Werewolf doing 500 push-ups in wolf form...',
  tq_mummy_audience: 'Mummy researching which civilization visitors fear most...',
  tq_werewolf_audience: 'Werewolf tracking which visitors have dog allergies...',

  view_building: 'Predio',
  view_other_buildings: '< Outros Predios',
  view_lobby: 'Saguao',
  view_facilities: 'Instalacoes',
  view_academy: 'Academia',
  lobby_title: 'Saguao',
  lobby_queue: 'Fila de espera',
  lobby_queue_empty: 'Nenhum visitante esperando',
  lobby_active_teams: 'Explorando: {cur}/{max} equipes',
  lobby_wait_time: 'Espera: {n}s',
  lobby_team_size: '{n} visitantes',
  lobby_staff: 'Funcionarios do saguao',
  lobby_staff_empty: 'Nenhum funcionario designado',
  lobby_assign_staff: 'Designar funcionario',
  lobby_unassign_staff: 'Remover',
  lobby_staff_effect: 'Reduz tempo de espera, melhora satisfacao',
  lobby_ticket_booth: 'Bilheteria',
  facilities_view_title: 'Gerenciar instalacoes',
  facilities_view_empty: 'Nenhuma instalacao construida. Construa no Menu!',
  facility_staff: 'Funcionario',
  facility_staff_none: 'Sem funcionario',
  facility_assign_staff: 'Designar funcionario',
  facility_unassign_staff: 'Remover funcionario',
  facility_staff_bonus: 'Funcionarios melhoram a qualidade do servico',
  facility_restroom: 'Banheiro',
  facility_restroom_desc: 'Previne penalidade de satisfacao',
  facility_restroom_bonus: 'Sem penalidade quando construido',
  facility_parking_lot: 'Estacionamento',
  facility_parking_lot_desc: 'Aumenta a taxa de chegada de visitantes',
  facility_parking_lot_bonus: '+{pct}% taxa de visitantes por nivel',
  facility_first_aid: 'Posto de socorro',
  facility_first_aid_desc: 'Cuida de visitantes que fugiram/desmaiaram',
  facility_first_aid_bonus: 'Previne avaliacoes negativas por fuga',
  facility_arcade: 'Arcade',
  facility_arcade_desc: 'Mini-jogos e atracoes de terror',
  facility_arcade_bonus: 'Aumenta a empolgacao dos visitantes',
  facility_fortune_teller: 'Vidente',
  facility_fortune_teller_desc: 'Leitura de taro e quiromancia',
  facility_fortune_teller_bonus: 'Melhora a satisfacao',
  facility_escape_room: 'Sala de Fuga',
  facility_escape_room_desc: 'Desafio de puzzle de terror com tempo',
  facility_escape_room_bonus: 'Alta renda por visitante',
  facility_stage: 'Palco',
  facility_stage_desc: 'Shows e performances de fantasmas',
  facility_stage_bonus: 'Aumenta a fama do parque',
  facility_voodoo_shop: 'Loja Vudu',
  facility_voodoo_shop_desc: 'Amuletos amaldicoados e itens magicos',
  facility_voodoo_shop_bonus: 'Mais itens especiais',
  facility_ghost_cafe: 'Cafe Fantasma',
  facility_ghost_cafe_desc: 'Bebidas misteriosas feitas por fantasmas',
  facility_ghost_cafe_bonus: 'Visitantes ficam mais tempo',
  facility_phantom_cinema: 'Cinema Fantasma',
  facility_phantom_cinema_desc: 'Exibicao de filmes de terror sobrenatural',
  facility_phantom_cinema_bonus: 'Alta receita de ingressos',
  facility_skeleton_spa: 'Spa Esqueleto',
  facility_skeleton_spa_desc: 'Relaxamento ate os ossos',
  facility_skeleton_spa_bonus: 'Recuperacao de fadiga mais rapida',
  academy_title: 'Academia de Fantasmas',
  academy_empty: 'Contrate fantasmas primeiro!',
  academy_select_ghost: 'Selecione um fantasma para treinar',
  academy_select_training: 'Escolher curso de treinamento',
  academy_skill_level: 'Nv.{n}/{max}',
  academy_skill_maxed: 'DOMINADO',
  academy_training_time: '{sec}s',
  academy_training_cost: '{sp} SP',
  academy_in_progress: 'Treinando...',
  academy_complete: 'Completo!',
  academy_skip_ad: 'Pular (Anuncio)',
  academy_ghost_busy: 'Fantasma ocupado',
  academy_acting: 'Aula de atuacao',
  academy_acting_desc: 'Melhora a atuacao e o ritmo do susto',
  academy_acting_effect: 'Efeito de susto +20% por nivel',
  academy_human_relations: 'Relacoes humanas',
  academy_human_relations_desc: 'Aprenda a entender os visitantes',
  academy_human_relations_effect: 'Satisfacao +15% por nivel',
  academy_psychology: 'Psicologia',
  academy_psychology_desc: 'Atinja as fraquezas do visitante',
  academy_psychology_effect: 'Bonus de fraqueza por nivel',
  academy_special_fx: 'Efeitos especiais',
  academy_special_fx_desc: 'Domine o uso de aderecos e efeitos',
  academy_special_fx_effect: 'Bonus de aderecos x2 por nivel',
  academy_fitness: 'Treinamento fisico',
  academy_fitness_desc: 'Aumente a resistencia e a vitalidade',
  academy_fitness_effect: 'Recuperacao de fadiga +50% por nivel',
  academy_teamwork: 'Trabalho em equipe',
  academy_teamwork_desc: 'Coordene com fantasmas proximos',
  academy_teamwork_effect: 'Susto em cadeia +30% por nivel',
  academy_customer_service: 'Atendimento ao cliente',
  academy_customer_service_desc: 'Melhore o servico do saguao/instalacoes',
  academy_customer_service_effect: 'Melhoria de qualidade de servico por nivel',
  facility_detail_income: 'Renda',
  facility_detail_sp_per_group: '{n} SP / grupo',
  facility_detail_bonus: 'Bonus',
  facility_detail_upgrade: 'Melhorar ({sp} SP)',
  facility_detail_assign: 'Atribuir funcionario',
  facility_detail_status_active: 'Operando',
  facility_detail_status_buildable: 'Disponivel',
  facility_detail_status_locked: 'Bloqueado',
  facility_detail_no_income: 'Sem renda direta',
  ghost_role_scare: 'Dever de susto',
  ghost_role_lobby_staff: 'Funcionario do saguao',
  ghost_role_facility_staff: 'Funcionario da instalacao',
  ghost_role_instructor: 'Instrutor',
  shop_pro_ghosts: 'Professional Ghosts',
  pro_ghost_badge: 'PRO',
  ghost_grim_reaper: 'Grim Reaper',
  ghost_origin_underworld: 'Underworld',
  ghost_grim_reaper_skill: 'Soul Harvest: All fear types S-rank, absolute terror',
  ghost_grim_reaper_quote: 'Your time has come... just kidding. Or am I?',
  ghost_grim_reaper_fatigued: 'Even death needs a vacation sometimes...',
  ghost_grim_reaper_unique: 'Instant max fear on any visitor type',
  ghost_blood_count: 'Blood Count',
  ghost_origin_transylvania: 'Transylvania',
  ghost_blood_count_skill: 'Blood Charm: Charisma-based visual + psychological S-rank',
  ghost_blood_count_quote: 'I do not drink... wine.',
  ghost_blood_count_fatigued: 'The sun... it burns... need coffin...',
  ghost_blood_count_unique: 'Charm aura: adjacent rooms get +20% scare',
  ghost_well_spirit: 'Well Spirit',
  ghost_well_spirit_skill: 'Well Crawl: Psychological horror S-rank, lingering dread',
  ghost_well_spirit_quote: '...seven days...',
  ghost_well_spirit_fatigued: 'My hair is so tangled... need conditioner...',
  ghost_well_spirit_unique: 'Lingering fear: visitors stay scared in next room',
  ghost_nightmare_specter: 'Nightmare Specter',
  ghost_origin_dreamworld: 'Dream World',
  ghost_nightmare_specter_skill: 'Nightmare Slash: Physical + psychological S-rank dream terror',
  ghost_nightmare_specter_quote: 'Sweet dreams... or not.',
  ghost_nightmare_specter_fatigued: 'Even nightmares need beauty sleep...',
  ghost_nightmare_specter_unique: 'Dream invasion: double scare on sleeping visitors',
  ghost_shadow_stalker: 'Shadow Stalker',
  ghost_origin_void: 'The Void',
  ghost_shadow_stalker_skill: 'Static Presence: Psychological horror max, stalker-type',
  ghost_shadow_stalker_quote: '...',
  ghost_shadow_stalker_fatigued: '......',
  ghost_shadow_stalker_unique: 'Static aura: all visitors on floor get +15% fear',

  // === Visitor Reactions ===
  reaction_angry: '#!',
  reaction_excited: '*',

  lobby_room_ticket_booth: 'Bilheteria',
  lobby_room_ticket_booth_desc: 'Onde os visitantes compram ingressos',
  lobby_room_ticket_booth_effect: 'Velocidade base de venda de ingressos',
  lobby_room_waiting_lounge: 'Sala de espera',
  lobby_room_waiting_lounge_desc: 'Area de espera confortavel com assentos',
  lobby_room_waiting_lounge_effect: '+20% paciencia dos visitantes por nivel',
  lobby_room_vip_lounge: 'Lounge VIP',
  lobby_room_vip_lounge_desc: 'Sala premium para visitantes VIP',
  lobby_room_vip_lounge_effect: 'Visitantes VIP gastam 2x mais SP',
  lobby_room_reservation_center: 'Central de reservas',
  lobby_room_reservation_center_desc: 'Sistema de reserva antecipada',
  lobby_room_reservation_center_effect: '+15% taxa de visitantes por nivel',

  lobby_build_floor: '+ {name} ({sp} SP)',
  lobby_build_select: 'Selecionar instalacao...',
  lobby_add_floor: '+ {sp} SP',
  lobby_empty_floor: 'Construir Instalacao',
  lobby_select_facility: 'Selecionar Instalacao',
  lobby_props_count: '{n} itens',
  lobby_props_title: 'Objetos',
  lobby_tab_info: 'Info',
  lobby_tab_objects: 'Objetos',
  lobby_tab_upgrade: 'Melhorar',
  lobby_tab_demolish: 'Demolir',
  lobby_demolish_confirm: 'Remover esta instalacao? O andar ficara vazio.',
  lobby_demolish_btn: 'Demolir Instalacao',
  lobby_no_ghost: 'Sem funcionario',
  lobby_upgrade_max: 'Nivel Max',
  lobby_upgrade_next: 'Lv.{from} -> Lv.{to}',
  lobby_upgrade_effect: 'Efeito apos melhoria:',
  facility_build_floor: 'Construir',

  facility_map_title: 'Area de Instalacoes',
  facility_build_here: 'Construir',
  facility_select_to_build: 'Selecionar Instalacao',
  facility_all_built: 'Todas as instalacoes foram construidas.',
  facility_unlock_plot: '{sp} SP',
  facility_unlock_plot_title: 'Desbloquear Lote',
  facility_unlock_plot_desc: 'Desbloqueie este lote por {sp} SP para construir uma nova instalacao.',
  facility_unlock_plot_btn: 'Desbloquear ({sp} SP)',
  facility_build_popup_title: 'Construir Instalacao',
  facility_build_action: 'Construir',
  facility_select_theme: 'Selecionar Tema',
  facility_upgrade_preview: 'Efeitos da Melhoria',
  facility_upgrade_revenue: 'Receita por grupo',
  facility_upgrade_bonus: 'Bonus de Receita',
  facility_upgrade_capacity: 'Capacidade',
  facility_upgrade_current: 'Atual',
  facility_upgrade_next: 'Proximo',
  facility_upgrade_max_level: 'Nivel maximo alcancado',
  facility_revenue: 'Receita',
  facility_total_revenue: 'Receita Total',
  facility_hourly_revenue: 'Por Grupo',
  facility_set_price: 'Definir Preco',
  facility_price_hint_high: 'Preco alto: mais lucro, menos visitantes',
  facility_price_hint_low: 'Preco baixo: mais visitantes, menos lucro',
  facility_price_hint_free: 'Entrada gratuita',
  facility_price_hint_normal: 'Preco equilibrado',
  facility_open: 'Abrir',
  facility_close: 'Fechar',
  facility_closed_badge: 'FECHADO',
  facility_needs_staff: 'Atribua equipe para abrir',
  facility_demolish: 'Demolir',
  facility_demolish_confirm: 'Demolir {name}? Nao pode ser desfeito.',
  facility_move: 'Mover',
  facility_move_select: 'Selecione um lote vazio para mover',
  facility_move_no_empty: 'Nenhum lote vazio disponivel.',

  lobby_prop_sofa: 'Sofa',
  lobby_prop_sofa_desc: 'Assentos confortaveis para visitantes',
  lobby_prop_tv_screen: 'Tela de TV',
  lobby_prop_tv_screen_desc: 'Entretenimento durante a espera',
  lobby_prop_vending_machine: 'Maquina de venda',
  lobby_prop_vending_machine_desc: 'Lanches e bebidas para visitantes',
  lobby_prop_info_sign: 'Placa informativa',
  lobby_prop_info_sign_desc: 'Orientar visitantes',
  lobby_prop_potted_plant: 'Vaso de planta',
  lobby_prop_potted_plant_desc: 'Um toque de verde sinistro',
  lobby_prop_umbrella_stand: 'Porta-guarda-chuvas',
  lobby_prop_umbrella_stand_desc: 'Para guarda-chuvas molhados',

  fac_prop_display_shelf: 'Prateleira de exibicao',
  fac_prop_display_shelf_desc: 'Exibir produtos de forma atrativa',
  fac_prop_cash_register: 'Caixa registradora',
  fac_prop_cash_register_desc: 'Acelerar transacoes',
  fac_prop_coffee_machine: 'Maquina de cafe',
  fac_prop_coffee_machine_desc: 'Servir bebidas quentes',
  fac_prop_menu_board: 'Quadro de cardapio',
  fac_prop_menu_board_desc: 'Exibir opcoes de comida',
  fac_prop_camera_light: 'Luz de camera',
  fac_prop_camera_light_desc: 'Melhor iluminacao para fotos',
  fac_prop_backdrop: 'Cenario de fundo',
  fac_prop_backdrop_desc: 'Fundo tematico para fotos',
  fac_prop_hand_dryer: 'Secador de maos',
  fac_prop_hand_dryer_desc: 'Manter tudo limpo e seco',
  fac_prop_mirror: 'Espelho',
  fac_prop_mirror_desc: 'Essencial de banheiro assustador',
  fac_prop_parking_sign: 'Placa de estacionamento',
  fac_prop_parking_sign_desc: 'Direcionar visitantes ao estacionamento',
  fac_prop_barrier_gate: 'Cancela',
  fac_prop_barrier_gate_desc: 'Controle automatico de estacionamento',
  fac_prop_first_aid_kit: 'Kit de primeiros socorros',
  fac_prop_first_aid_kit_desc: 'Suprimentos medicos basicos',
  fac_prop_stretcher: 'Maca',
  fac_prop_stretcher_desc: 'Para visitantes que desmaiaram de medo',

  tab_facilities: 'Instalacoes',
  tab_hire: 'Contratar',
  tab_staff: 'Equipe',
  tab_support_facilities: 'Instalacoes',
  tab_achievements: 'Conquistas',
  achievements_title: 'Conquistas',
  achievements_coming_soon: 'Em breve...',
  facilities_mgmt_title: 'Gestao de Instalacoes',
  facility_condition: 'Condicao',
  facility_hygiene: 'Higiene',
  facility_condition_warning: 'Precisa de reparo!',
  facility_hygiene_warning: 'Precisa de limpeza!',
  dispatch_repair: 'Enviar reparador',
  dispatch_clean: 'Enviar limpeza',
  no_repair_staff: 'Sem equipe de reparo',
  no_janitor_staff: 'Sem equipe de limpeza',
  repair_dispatched: 'Reparador enviado',
  clean_dispatched: 'Limpeza enviada',
  ticket_section_title: 'Preco do ingresso',
  expected_visitors: 'Visitantes esperados: ~{n}/dia',
  star_rating_title: 'Avaliacao dos visitantes',
  star_level_gray: 'Estrela cinza',
  star_level_bronze: 'Estrela bronze',
  star_level_silver: 'Estrela prata',
  star_level_gold: 'Estrela ouro',
  star_level_rainbow: 'Estrela arco-iris',
  star_evolution_max: 'A melhor casa assombrada',
  star_current: '{cur}/{max}',
  hire_title: 'Contratar equipe',
  hire_scare_section: 'Especialistas em susto',
  hire_staff_section: 'Equipe de instalacoes',
  staff_role_repair: 'Reparador',
  staff_role_janitor: 'Faxineiro',
  staff_role_ticket: 'Vendedor de ingressos',
  staff_role_guide: 'Guia',
  staff_role_repair_desc: 'Repara deterioracao',
  staff_role_janitor_desc: 'Mantem a higiene',
  staff_role_ticket_desc: 'Opera o lobby',
  staff_role_guide_desc: 'Bonus de satisfacao',
  hire_cost_label: '{sp} SP',
  staff_title: 'Lista de equipe',
  staff_empty: 'Nenhuma equipe contratada.',
  staff_detail_title: 'Detalhes da equipe',
  staff_detail_type: 'Tipo',
  staff_detail_role: 'Funcao',
  staff_detail_grade: 'Grau',
  staff_detail_skills: 'Habilidades',
  staff_detail_assigned: 'Designado para',
  staff_detail_not_assigned: 'Nao designado',
  staff_detail_hired_days: 'Contratado: Dia {n}',
  staff_detail_praise: 'Elogios: {n}',
  skill_acting: 'Atuacao',
  skill_friendliness: 'Simpatia',
  skill_psychology: 'Psicologia',
  skill_special_fx: 'Efeitos especiais',
  skill_fitness: 'Condicao fisica',
  skill_teamwork: 'Trabalho em equipe',
  skill_service: 'Atendimento',
  room_detail_tab_info: 'Info',
  room_detail_tab_props: 'Objetos',
  room_detail_tab_upgrade: 'Melhoria',
  room_detail_tab_demolish: 'Demolir',
  room_detail_ghost_none: 'Nao atribuido',
  room_detail_condition: 'Condicao',
  room_detail_hygiene: 'Higiene',
  room_detail_request_repair: 'Solicitar Reparo ({sp} SP)',
  room_detail_request_cleaning: 'Solicitar Limpeza ({sp} SP)',
  room_detail_repairing: 'Reparando... {sec}s',
  room_detail_cleaning: 'Limpando... {sec}s',
  room_detail_collapsed: 'DESABOU',
  room_detail_collapsed_desc: 'A sala desabou. Repare para restaurar.',
  room_detail_condition_ok: 'Condicao boa',
  room_detail_hygiene_ok: 'Higiene boa',
  room_upgrade_structure: 'Reforco Estrutural',
  room_upgrade_structure_desc: 'Reduz a deterioracao por visita',
  room_upgrade_structure_effect: '-{pct}% deterioracao por nivel',
  room_upgrade_structure_bonus_10: 'Sala Resistente: Custo de reparo -30%',
  room_upgrade_structure_bonus_20: 'Sala Imortal: Condicao minima 50',
  room_upgrade_purify: 'Auto Purificacao',
  room_upgrade_purify_desc: 'Reduz a perda de higiene por visita',
  room_upgrade_purify_effect: '-{pct}% perda de higiene por nivel',
  room_upgrade_purify_bonus_10: 'Sala Perfumada: Satisfacao +10%',
  room_upgrade_purify_bonus_20: 'Magia de Limpeza: Recuperacao automatica',
  room_upgrade_level: 'Nv.{cur}/{max}',
  room_upgrade_cost: 'Melhorar ({sp} SP)',
  room_upgrade_max: 'MAX',
  room_upgrade_bonus_unlocked: 'Desbloqueado!',
  room_upgrade_bonus_locked: 'Bonus Nv.{n}',
  room_demolish_warning: 'Demolir esta sala destruira todos os objetos e melhorias permanentemente.',
  room_demolish_cost: 'Custo: Gratis',
  room_demolish_btn: 'Demolir Sala',
  room_demolish_confirm: 'Tem certeza que quer demolir esta sala? Nao pode ser desfeito.',
  room_props_installed: 'Objetos Instalados',
  room_props_available: 'Objetos Disponiveis',
  room_props_none: 'Sem objetos',
  menu_bgm: 'BGM',
  menu_sfx: 'SFX',
  menu_language: 'Idioma',
  menu_reset: 'Reiniciar jogo',
  menu_reset_confirm: 'Tem certeza? Nao pode ser desfeito.',
  menu_info: 'Info do jogo',
  menu_version: 'Versao {v}',
  menu_on: 'ON',
  menu_off: 'OFF',

  // === Room Emotion Stats ===
  stat_fear: 'Medo',
  stat_thrill: 'Emocao',
  stat_atmosphere: 'Ambiente',
  stat_fun: 'Diversao',
  stat_total: 'Atributos',
  room_grade: 'Nota',
  grade_S: 'S',
  grade_A: 'A',
  grade_B: 'B',
  grade_C: 'C',
  grade_D: 'D',
  grade_F: 'F',

  phase_day: 'Prep',
  phase_evening: 'Aberto',
  phase_night: 'Fechado',
  phase_day_icon: '\u2600',
  phase_evening_icon: '\uD83C\uDF19',
  phase_night_icon: '\u2B50',
  phase_remaining: '{sec}s',
  phase_day_hint: 'Prepare sua casa assombrada! Repare, posicione fantasmas, melhore.',
  phase_evening_hint: 'Horario comercial! Os visitantes estao chegando.',
  open_now_btn: 'ABRIR AGORA',
  speed_btn: 'x{n}',
  day_auto_open_hint: 'Anoiteceu! Hora de abrir.',
  evening_ending_hint: 'Hora de fechar! Encerrando...',
  floor1_blocked_warning: 'Entrada bloqueada! Repare o Andar 1!',
  gstaff_title: 'Fantasmas Staff',
  gstaff_repairman: 'Fantasma Reparador',
  gstaff_repairman_desc: 'Um fantasma que atravessa paredes para consertar salas',
  gstaff_repairman_effect: 'Repara a sala com menor condicao',
  gstaff_janitor: 'Fantasma Faxineiro',
  gstaff_janitor_desc: 'Limpa salas com energia espectral',
  gstaff_janitor_effect: 'Limpa a sala com menor higiene',
  gstaff_promoter: 'Fantasma Promotor',
  gstaff_promoter_desc: 'Atrai visitantes com sussurros sinistros',
  gstaff_promoter_effect: '+20% visitantes por nivel',
  gstaff_medic: 'Fantasma Curador',
  gstaff_medic_desc: 'Acalma visitantes assustados com charme fantasmal',
  gstaff_medic_effect: 'Visitantes que fogem deixam avaliacoes neutras',
  gstaff_security: 'Fantasma Guardiao',
  gstaff_security_desc: 'Mantem a ordem com presenca intimidadora',
  gstaff_security_effect: '+10% satisfacao por nivel',
  gstaff_hire_cost: 'Invocar: {sp} SP',
  gstaff_salary: 'Manutencao: {sp} SP/dia',
  gstaff_fire: 'Exorcizar',
  gstaff_fire_confirm: 'Exorcizar este fantasma?',
  gstaff_level: 'Nv.{n}',
  gstaff_none: 'Nenhum fantasma invocado.',
  day_summary_salaries: 'Salarios',
  day_summary_net_earnings: 'Ganho Liquido',
  day_summary_street_visitors: 'Visitantes de Rua',
  day_summary_street_revenue: 'Receita de Rua',
  day_summary_reviews_title: 'AVALIACOES DOS VISITANTES',
  day_summary_avg_stars: 'NOTA MEDIA',
  day_summary_fame_change: 'FAMA',
  day_summary_no_reviews: 'Sem avaliacoes hoje',
  day_summary_review_visitor: 'Visitante #{n}',
  day_summary_highlight: 'DESTAQUE',

  // === Tutorial ===
  tutorial_welcome_title: 'Bem-vindo a Casa Assombrada!',
  tutorial_welcome_body: 'A partir de hoje voce e o dono desta casa assombrada. Vamos criar a casa assombrada mais divertida com seus fantasminhas!',
  tutorial_welcome_btn: 'Vamos la!',
  tutorial_build_title: 'Construir um Comodo',
  tutorial_build_body: 'Primeiro, vamos construir um comodo. Toque no botao "+" para escolher o tipo de comodo.',
  tutorial_ghost_title: 'Colocar um Fantasma',
  tutorial_ghost_body: 'Coloque um fantasma no comodo para assustar os visitantes. Toque no comodo para colocar um fantasma.',
  tutorial_open_title: 'Abrir a Casa',
  tutorial_open_body: 'Tudo pronto! Toque no botao "Abrir" abaixo para receber visitantes.',
  tutorial_facility_intro_title: 'Area de Instalacoes',
  tutorial_facility_intro_body: 'Seu parque tem terrenos para instalacoes! Construa lojas e atracoes para ganhar mais.',
  tutorial_facility_build_title: 'Construir Instalacao',
  tutorial_facility_build_body: 'Toque em um terreno vazio e escolha uma instalacao. Experimente a Loja de Presentes ou o Snack Bar!',
  tutorial_facility_staff_title: 'Designar Funcionario',
  tutorial_facility_staff_body: 'Designe um fantasma para a nova instalacao. Funcionarios aumentam a receita em 20%!',
  tutorial_facility_open_title: 'Abrir Instalacao',
  tutorial_facility_open_body: 'Abra sua instalacao para os visitantes usarem. Voce tambem pode definir precos!',
  tutorial_done_title: 'Tutorial Completo!',
  tutorial_done_body: 'Incrivel! Voce ja domina as operacoes basicas. Continue expandindo sua casa assombrada!',
  tutorial_skip: 'Pular',
  tutorial_next: 'Proximo',
  tutorial_got_it: 'Entendi!',

  // === Story Arc System ===
  story_intro: 'Intro',
  story_rising: 'Ascensao',
  story_climax: 'Climax',
  story_resolution: 'Desfecho',
  story_grade: 'Arco: {grade} (+{bonus}% SP)',
  story_bonus: '+{bonus}% SP',
  story_guide_title: 'Sistema de Arco Narrativo Desbloqueado!',
  story_guide_desc: 'Com 4+ salas, organize seus andares para criar um arco narrativo e ganhar SP extra!',
  story_role_label: '{role}',
  story_intro_desc: 'Criar clima: alta atmosfera, baixo medo',
  story_rising_desc: 'Aumentar tensao: aumentar medo e emocao',
  story_climax_desc: 'Terror maximo: medo e emocao no maximo',
  story_resolution_desc: 'Alivio e diversao: aumentar diversao',
  story_room_role: 'Papel narrativo: {role}',
  story_none: 'Nenhum',

  // === Room Available Props ===
  room_available_props: 'Instalaveis: {props}',

  // === Lobby Queue System ===
  lq_waiting_count: 'Espera: {n}/{max}',
  lq_avg_patience: 'Paciencia media: {n}%',
  lq_queue_empty: 'Nenhum visitante na fila',

  // === Lobby Facilities ===
  lf_title: 'Instalacoes do saguao',
  lf_patience_bonus: 'Paciencia -{n}%',
  lf_revenue_bonus: '+{n} SP/visitante',
  lf_npc_bonus: 'NPC: +15% paciencia, +20% receita',
  lf_npc_staff: 'Funcionario NPC',

  lf_ticket_booth: 'Bilheteria',
  lf_ticket_booth_desc: 'Balcao essencial de venda de ingressos',
  lf_waiting_lounge: 'Sala de Espera',
  lf_waiting_lounge_desc: 'Area de espera confortavel com assentos (+paciencia)',
  lf_vip_lounge: 'Lounge VIP',
  lf_vip_lounge_desc: 'Sala premium para visitantes VIP',
  lf_reservation_center: 'Central de Reservas',
  lf_reservation_center_desc: 'Sistema de reserva previa para visitantes (+paciencia)',
  lf_poster_wall: 'Mural de posters',
  lf_poster_wall_desc: 'Posters assustadores aumentam a expectativa (+paciencia)',
  lf_snack_cart: 'Carrinho de lanches',
  lf_snack_cart_desc: 'Lanches mantem a paciencia dos visitantes',
  lf_souvenir_booth: 'Loja de lembrancinhas',
  lf_souvenir_booth_desc: 'Venda lembrancinhas para receita extra',
  lf_photo_zone: 'Area de fotos',
  lf_photo_zone_desc: 'Visitantes tiram fotos, aumentando fama e receita',
  lf_tv_monitor: 'Monitor de TV',
  lf_tv_monitor_desc: 'Videos de terror mantem os visitantes entretidos',
  lf_costume_rental: 'Aluguel de fantasias',
  lf_costume_rental_desc: 'Visitantes alugam fantasias para mais diversao e receita',
  lf_fortune_booth: 'Barraca da fortuna',
  lf_fortune_booth_desc: 'Adivinhacao misteriosa cria atmosfera de terror',
  lf_built_badge: 'Construido',

  // === Lobby Facility Unique Effects ===
  lf_ue_ticket_speed: 'Velocidade do ingresso: intervalo de entrada -15% por nivel',
  lf_ue_max_queue_up: 'Capacidade: fila maxima +5 por nivel',
  lf_ue_vip_rate_up: 'Taxa VIP: aparicao VIP x2 por nivel',
  lf_ue_satisfaction_up: 'Antecipacao: satisfacao base +20%',
  lf_ue_emergency_patience: 'Lanche de emergencia: +15 paciencia para visitantes baixos',
  lf_ue_revisit_rate_up: 'Lembrancinhas: bonus de visitantes do dia seguinte +15%',
  lf_ue_reputation_per_day: 'Compartilhar SNS: reputacao diaria +2 por nivel',
  lf_ue_anticipation_up: 'Preview de terror: aumento de empolgacao +40%',
  lf_ue_fun_bonus: 'Fantasias: stat de diversao +15 por nivel',
  lf_ue_random_sp_bonus: 'Fortuna: chance de bonus SP aleatorio +10%',
  ticket_price_setting: 'Preco do ingresso',

  // === Lobby Facility Props ===
  lobby_prop_candle: 'Vela',
  lobby_prop_candle_desc: 'Uma vela bruxuleante para ambiente',
  lobby_prop_cobweb: 'Teia de aranha',
  lobby_prop_cobweb_desc: 'Teias de aranha assustadoras',
  lobby_prop_pumpkin: 'Abobora',
  lobby_prop_pumpkin_desc: 'Lanterna de abobora classica',
  lobby_prop_magazine_rack: 'Revisteiro',
  lobby_prop_magazine_rack_desc: 'Revistas de terror para espera',
  lobby_prop_chandelier: 'Lustre',
  lobby_prop_chandelier_desc: 'Elegante lustre gotico',
  lobby_prop_wine_glass: 'Taca de vinho',
  lobby_prop_wine_glass_desc: 'Tacas de cristal para ambiente VIP',
  lobby_prop_velvet_curtain: 'Cortina de veludo',
  lobby_prop_velvet_curtain_desc: 'Luxuosas cortinas de veludo',
  lobby_prop_gold_frame: 'Moldura dourada',
  lobby_prop_gold_frame_desc: 'Moldura ornamental dourada',
  lobby_prop_picture_frame: 'Moldura',
  lobby_prop_picture_frame_desc: 'Retrato amaldicoado na parede',
  lobby_prop_spotlight: 'Holofote',
  lobby_prop_spotlight_desc: 'Iluminacao dramatica para exibicoes',
  lobby_prop_skull_ornament: 'Ornamento de caveira',
  lobby_prop_skull_ornament_desc: 'Caveira decorativa assustadora',
  lobby_prop_pumpkin_cookie: 'Biscoito de abobora',
  lobby_prop_pumpkin_cookie_desc: 'Deliciosos biscoitos em forma de abobora',
  lobby_prop_ghost_drink: 'Bebida fantasma',
  lobby_prop_ghost_drink_desc: 'Bebida misteriosa brilhante',
  lobby_prop_napkin_holder: 'Porta-guardanapos',
  lobby_prop_napkin_holder_desc: 'Mantem a area de lanches organizada',
  lobby_prop_display_shelf: 'Prateleira de exibicao',
  lobby_prop_display_shelf_desc: 'Exibe lembrancinhas de forma atraente',
  lobby_prop_plush_doll: 'Boneco de pelucia',
  lobby_prop_plush_doll_desc: 'Pelucia de fantasma fofa',
  lobby_prop_keychain_rack: 'Suporte de chaveiros',
  lobby_prop_keychain_rack_desc: 'Suporte giratoria de chaveiros assustadores',
  lobby_prop_wrapping_paper: 'Papel de presente',
  lobby_prop_wrapping_paper_desc: 'Papel de presente tematico de Halloween',
  lobby_prop_backdrop: 'Cenario',
  lobby_prop_backdrop_desc: 'Cenario de fotos tematico',
  lobby_prop_prop_box: 'Caixa de acessorios',
  lobby_prop_prop_box_desc: 'Caixa de acessorios divertidos para fotos',
  lobby_prop_mask_stand: 'Suporte de mascaras',
  lobby_prop_mask_stand_desc: 'Exibicao de mascaras assustadoras para fotos',
  lobby_prop_antenna: 'Antena',
  lobby_prop_antenna_desc: 'Receptor de sinal de TV',
  lobby_prop_remote_control: 'Controle remoto',
  lobby_prop_remote_control_desc: 'Controla os canais de TV',
  lobby_prop_speaker: 'Alto-falante',
  lobby_prop_speaker_desc: 'Som surround para filmes de terror',
  lobby_prop_cable_wires: 'Fios',
  lobby_prop_cable_wires_desc: 'Fios enrolados adicionam um toque assustador',
  lobby_prop_clothes_rack: 'Cabide',
  lobby_prop_clothes_rack_desc: 'Cabide com fantasias assustadoras',
  lobby_prop_mirror: 'Espelho',
  lobby_prop_mirror_desc: 'Espelho de corpo inteiro para checar fantasias',
  lobby_prop_makeup_table: 'Mesa de maquiagem',
  lobby_prop_makeup_table_desc: 'Aplique maquiagem assustadora aqui',
  lobby_prop_wig_stand: 'Suporte de perucas',
  lobby_prop_wig_stand_desc: 'Colecao de perucas assustadoras',
  lobby_prop_crystal_ball: 'Bola de cristal',
  lobby_prop_crystal_ball_desc: 'Veja seu futuro assustador',
  lobby_prop_tarot_cards: 'Cartas de taro',
  lobby_prop_tarot_cards_desc: 'Cartas de adivinhacao misteriosas',
  lobby_prop_curtain: 'Cortina',
  lobby_prop_curtain_desc: 'Cortina mistica para a barraca da fortuna',
  lobby_prop_candelabra: 'Candelabro',
  lobby_prop_candelabra_desc: 'Candelabro de multiplos bracos para ambiente',

  lnpc_title: 'Lobby Ghost Patrol',
  lnpc_assign: 'Assign Ghost',
  lnpc_unassign: 'Remove',
  lnpc_desc: 'Ghosts scare waiting visitors, boosting patience',
  lnpc_slot: '{cur}/{max} Ghosts',
  evt_time_remaining: '{sec}s remaining',
  evt_rain_name: 'Sudden Rain',
  evt_rain_desc: 'Heavy rain falls suddenly. Visitors without umbrellas are leaving the queue.',
  evt_rain_c1: 'Ignore',
  evt_rain_c2: 'Hand out umbrellas (100 SP)',
  evt_rain_r1: '3 visitors left the queue in the rain.',
  evt_rain_r2: 'Umbrellas were handed out. Everyone stays dry.',
  evt_couple_fight_name: 'Couple Fight',
  evt_couple_fight_desc: 'A couple starts arguing loudly in the queue, disturbing others.',
  evt_couple_fight_c1: 'Handle it',
  evt_couple_fight_r1: 'The situation has been dealt with.',
  evt_crying_child_name: 'Crying Child',
  evt_crying_child_desc: 'A child starts crying in the queue, making others uneasy.',
  evt_crying_child_c1: 'Give candy (50 SP)',
  evt_crying_child_c2: 'Ignore',
  evt_crying_child_r1: 'The candy cheered the child up.',
  evt_crying_child_r2: 'The crying continued, testing everyone\'s patience.',
  evt_blackout_name: 'Power Outage',
  evt_blackout_desc: 'A sudden power outage plunges everything into darkness.',
  evt_blackout_c1: 'Start generator (200 SP)',
  evt_blackout_c2: 'Wait it out',
  evt_blackout_r1: 'The generator kicked in. Business continues.',
  evt_blackout_r2: 'Everyone waited in the dark for a while.',
  evt_line_cutter_name: 'Line Cutter',
  evt_line_cutter_desc: 'Someone brazenly cuts into the front of the queue.',
  evt_line_cutter_c1: 'Call security',
  evt_line_cutter_c2: 'Ignore',
  evt_line_cutter_r1: 'Security escorted the line cutter out.',
  evt_line_cutter_r2: 'Others in line grumble in frustration.',
  evt_fake_ghost_name: 'Fake Ghost Prank',
  evt_fake_ghost_desc: 'A visitor dressed as a ghost is scaring others in line. The crowd seems amused.',
  evt_fake_ghost_c1: 'Let them have fun',
  evt_fake_ghost_r1: 'The prank added to the spooky atmosphere. Reputation up!',
  evt_lost_item_name: 'Lost Item Report',
  evt_lost_item_desc: 'A visitor reports a lost item near the entrance.',
  evt_lost_item_c1: 'Help find it (Reputation +5)',
  evt_lost_item_c2: 'Ignore',
  evt_lost_item_r1: 'The lost item was found! The visitor is grateful.',
  evt_lost_item_r2: 'The visitor left disappointed.',
  evt_snack_sold_out_name: 'Snacks Sold Out',
  evt_snack_sold_out_desc: 'The snack cart ran out of stock. Visitors are asking for snacks.',
  evt_snack_sold_out_c1: 'Emergency restock (100 SP)',
  evt_snack_sold_out_c2: 'Wait for next shipment',
  evt_snack_sold_out_r1: 'Snacks are back in stock.',
  evt_snack_sold_out_r2: 'Visitors will have to wait.',
  evt_sns_selfie_name: 'SNS Photo Op',
  evt_sns_selfie_desc: 'A visitor wants to take a selfie for social media.',
  evt_sns_selfie_c1: 'Acknowledge',
  evt_sns_selfie_r1: 'The post boosted your online presence.',
  evt_hot_weather_name: 'Scorching Heat',
  evt_hot_weather_desc: 'The temperature soars. Visitors look uncomfortable in the heat.',
  evt_hot_weather_c1: 'Free drinks (150 SP)',
  evt_hot_weather_c2: 'Endure it',
  evt_hot_weather_r1: 'Cool drinks refreshed everyone.',
  evt_hot_weather_r2: 'The heat is taking a toll on patience.',
  evt_tour_bus_name: 'Tour Bus Arrival',
  evt_tour_bus_desc: 'A tour bus just arrived! A large group of tourists floods the entrance.',
  evt_tour_bus_c1: 'Welcome them',
  evt_tour_bus_r1: 'The queue fills up with excited tourists.',
  evt_tv_coverage_name: 'TV Crew Request',
  evt_tv_coverage_desc: 'A local TV station wants to cover your haunted house.',
  evt_tv_coverage_c1: 'Accept (risky)',
  evt_tv_coverage_c2: 'Decline',
  evt_tv_coverage_r1: 'The coverage aired. Results vary...',
  evt_tv_coverage_r2: 'You politely declined the offer.',
  evt_spy_name: 'Rival Spy',
  evt_spy_desc: 'You spot someone suspiciously taking notes about your operations.',
  evt_spy_c1: 'Apprehend (need security)',
  evt_spy_c2: 'Ignore',
  evt_spy_r1: 'The spy was caught. You recovered valuable intel.',
  evt_spy_r2: 'Some of your ideas might leak to competitors.',
  evt_health_inspection_name: 'Health Inspection',
  evt_health_inspection_desc: 'Health inspectors arrive for a surprise visit.',
  evt_health_inspection_c1: 'Open the doors',
  evt_health_inspection_r1: 'The inspection is complete.',
  evt_halloween_season_name: 'Halloween Fever',
  evt_halloween_season_desc: 'Halloween spirit fills the air! Everyone is in the mood for scares.',
  evt_halloween_season_c1: 'Celebrate!',
  evt_halloween_season_r1: 'Halloween boost! Extra visitors and SP incoming.',
  evt_ghost_strike_name: 'Ghost Strike',
  evt_ghost_strike_desc: 'Overworked ghosts are refusing to scare. They demand better conditions.',
  evt_ghost_strike_c1: 'Pay bonus (500 SP)',
  evt_ghost_strike_c2: 'Wait it out',
  evt_ghost_strike_r1: 'The bonus satisfied the ghosts. Back to work!',
  evt_ghost_strike_r2: 'The strike continues for a while...',
  evt_mystery_visitor_name: 'Mystery Critic',
  evt_mystery_visitor_desc: 'A famous horror critic is visiting in disguise. Results depend on your reputation.',
  evt_mystery_visitor_c1: 'Best behavior',
  evt_mystery_visitor_r1: 'The critic revealed themselves and wrote a review.',
  evt_maintenance_accident_name: 'Equipment Malfunction',
  evt_maintenance_accident_desc: 'A piece of equipment malfunctioned in one of the rooms!',
  evt_maintenance_accident_c1: 'Assess damage',
  evt_maintenance_accident_r1: 'A room sustained damage. Repairs needed.',
  evt_sns_viral_name: 'Viral Video',
  evt_sns_viral_desc: 'A visitor\'s video of your haunted house went viral online!',
  evt_sns_viral_c1: 'Ride the wave',
  evt_sns_viral_r1: 'Your fame skyrockets! Reputation and SP boosted.',
  evt_total_blackout_name: 'Total Blackout',
  evt_total_blackout_desc: 'All power goes out across the entire area. Complete darkness.',
  evt_total_blackout_c1: 'Candlelight event (+Rep)',
  evt_total_blackout_c2: 'Wait for power',
  evt_total_blackout_r1: 'The candlelight atmosphere was a hit!',
  evt_total_blackout_r2: 'Everyone waited in the dark.',
  evt_famous_youtuber_name: 'Famous Streamer',
  evt_famous_youtuber_desc: 'A famous horror streamer with millions of followers is live-streaming from your haunted house!',
  evt_famous_youtuber_c1: 'Give VIP treatment',
  evt_famous_youtuber_r1: 'The stream was a massive hit! Reputation +30, SP +2000.',
  evt_celeb_visit_name: 'Celebrity Visit',
  evt_celeb_visit_desc: 'A major celebrity has arrived for a private scare session!',
  evt_celeb_visit_c1: 'Roll out the red carpet',
  evt_celeb_visit_r1: 'The celebrity loved it! Huge publicity boost.',
  evt_franchise_offer_name: 'Franchise Offer',
  evt_franchise_offer_desc: 'A corporation wants to franchise your haunted house brand.',
  evt_franchise_offer_c1: 'Accept (10000 SP)',
  evt_franchise_offer_c2: 'Decline',
  evt_franchise_offer_r1: 'Deal signed! A hefty payment arrives.',
  evt_franchise_offer_r2: 'You prefer to stay independent.',
  evt_intl_contest_name: 'International Horror Contest',
  evt_intl_contest_desc: 'Your haunted house is invited to an international scare competition!',
  evt_intl_contest_c1: 'Enter the contest',
  evt_intl_contest_r1: 'You earned recognition on the world stage!',
  evt_documentary_name: 'Documentary Filming',
  evt_documentary_desc: 'A documentary crew wants to film the story of your haunted house.',
  evt_documentary_c1: 'Allow filming',
  evt_documentary_r1: 'The documentary premieres to rave reviews!',
  evt_ghost_king_name: 'The Ghost King Appears',
  evt_ghost_king_desc: 'A legendary ghost is drawn to your haunted house by its fame.',
  evt_ghost_king_c1: 'Welcome the Ghost King',
  evt_ghost_king_r1: 'The Ghost King joins your ranks! Morale soars.',
  evt_gov_subsidy_name: 'Government Grant',
  evt_gov_subsidy_desc: 'The tourism board awards your haunted house a cultural preservation grant.',
  evt_gov_subsidy_c1: 'Accept the grant',
  evt_gov_subsidy_r1: 'Grant received: 5000 SP!',
  evt_vip_party_name: 'VIP Party Request',
  evt_vip_party_desc: 'A wealthy patron wants to rent the entire haunted house for a private party.',
  evt_vip_party_c1: 'Accept (8000 SP)',
  evt_vip_party_c2: 'Decline',
  evt_vip_party_r1: 'The VIP party was a huge success!',
  evt_vip_party_r2: 'You keep the doors open for regular visitors.',
  evt_horror_festival_name: 'Horror Festival',
  evt_horror_festival_desc: 'The city is hosting a horror festival and your haunted house is the main attraction!',
  evt_horror_festival_c1: 'Lead the festival',
  evt_horror_festival_r1: 'The festival was legendary! Massive rewards earned.',
  evt_legendary_review_name: 'Legendary Review',
  evt_legendary_review_desc: 'The world\'s most famous horror critic publishes a glowing review of your haunted house.',
  evt_legendary_review_c1: 'Bask in glory',
  evt_legendary_review_r1: 'A flood of 5-star reviews and fame follows!',

  // === Event Defense System ===
  evt_defense_badge: 'Auto-Resolved!',
  evt_defense_bonus: 'Bonus: +{sp} SP',
  evt_rain_defense: 'The roof upgrade keeps everyone dry. No one leaves!',
  evt_rain_hint: 'Tip: Upgrade Poster Wall to Lv.3 to auto-defend against rain.',
  evt_couple_fight_defense: 'Security steps in and mediates the situation calmly.',
  evt_couple_fight_hint: 'Tip: Hire a Security guard to auto-resolve fights.',
  evt_crying_child_defense: 'The snack cart attendant offers candy. The child smiles!',
  evt_crying_child_hint: 'Tip: Build a Snack Cart to automatically comfort crying children.',
  evt_blackout_defense: 'Emergency generators kick in automatically. No interruption!',
  evt_blackout_hint: 'Tip: Upgrade facilities to total Lv.10+ for backup power.',
  evt_line_cutter_defense: 'Security handles the line cutter immediately. Order restored!',
  evt_line_cutter_hint: 'Tip: Hire a Security guard to auto-handle line cutters.',
  evt_fake_ghost_defense: 'Your real NPC ghosts outshine the impostor. Excitement rises!',
  evt_fake_ghost_hint: 'Tip: Assign at least 1 NPC ghost to the lobby to overshadow fakers.',
  evt_lost_item_defense: 'Your staff quickly locates and returns the lost item!',
  evt_lost_item_hint: 'Tip: Hire 3+ staff members to auto-find lost items.',
  evt_snack_sold_out_defense: 'Inventory auto-restocked from reserves. Sales continue!',
  evt_snack_sold_out_hint: 'Tip: Upgrade Snack Cart to Lv.2+ for auto-restocking.',
  evt_sns_selfie_defense: 'Photo Zone provides the perfect backdrop. Great shots posted!',
  evt_sns_selfie_hint: 'Tip: Build a Photo Zone for automatic photo opportunities.',
  evt_hot_weather_defense: 'The monitor area has air conditioning. Everyone stays cool!',
  evt_hot_weather_hint: 'Tip: Install a TV Monitor to provide a cooled waiting area.',
  evt_tour_bus_defense: 'Plenty of room! All tourists are welcomed in.',
  evt_tour_bus_hint: 'Tip: Expand queue capacity to 15+ to accept large groups.',
  evt_tv_coverage_defense: 'With great reputation and many ghosts, the broadcast is a hit!',
  evt_tv_coverage_hint: 'Tip: Reach reputation 50+ and hire 5+ ghosts for guaranteed success.',
  evt_spy_defense: 'Security catches the spy red-handed! Intel recovered.',
  evt_spy_hint: 'Tip: Hire a Security guard to auto-detect spies.',
  evt_health_inspection_defense: 'Spotless! The inspector awards a hygiene certificate.',
  evt_health_inspection_hint: 'Tip: Hire a Janitor and keep average hygiene above 70.',
  evt_ghost_strike_defense: 'Ghosts are well-rested and happy. No strike today!',
  evt_ghost_strike_hint: 'Tip: Keep average ghost fatigue below 30 to prevent strikes.',
  evt_mystery_visitor_defense: 'Your excellent reputation earns a glowing review!',
  evt_mystery_visitor_hint: 'Tip: Maintain reputation at 60+ for guaranteed good reviews.',
  evt_maintenance_accident_defense: 'The repairman fixes it on the spot. Minimal damage!',
  evt_maintenance_accident_hint: 'Tip: Hire a Repairman to minimize equipment damage.',
  evt_total_blackout_defense: 'Repairman restores power instantly. Candle event bonus!',
  evt_total_blackout_hint: 'Tip: Hire a Repairman and reach facility Lv.15+ total.',
  evt_vip_party_defense: 'Costumes and photo zone make the party unforgettable! Normal business continues too.',
  evt_vip_party_hint: 'Tip: Build Costume Rental and Photo Zone for the ultimate party.',

  // === World Street ===
  world_title: 'Edifícios',
  world_subtitle: 'Selecione um edificio para gerenciar',
  world_empty_plot: 'Terreno vazio',
  world_build_new: 'Construir uma nova casa assombrada tematica',

  rename_building: 'Renomear edificio',
  rename_building_desc: 'Digite o novo nome',
  rename: 'Alterar',
  building_renamed: 'Nome alterado',

  construction_title: 'Novo edificio',
  construction_subtitle: 'Construa uma nova casa assombrada!',
  construction_name_label: 'Nome',
  construction_name_placeholder: 'Ex: Mansão noturna',
  construction_theme_label: 'Tema',
  construction_start: 'Construir',
  world_status_build: 'Construir',
  world_status_open: 'Aberto',
  world_status_ready: 'Preparando',
  theme_haunted_house: 'Casa assombrada',
  theme_haunted_house_desc: 'Experiência clássica de fantasmas',
  theme_abandoned_hospital: 'Hospital abandonado',
  theme_abandoned_hospital_desc: 'Horror médico e atmosfera de laboratório',
  theme_school_back_mountain: 'Montanha atrás da escola',
  theme_school_back_mountain_desc: 'Lendas escolares e trilhas assombradas',
  theme_cursed_circus: 'Circo Maldito',
  theme_cursed_circus_desc: 'Horror bizarro de um circo maldito',
  theme_ancient_temple: 'Templo Antigo',
  theme_ancient_temple_desc: 'Maldições místicas de um templo antigo',
  theme_pirate_ship: 'Navio Pirata',
  theme_pirate_ship_desc: 'Horror marítimo de um navio pirata amaldiçoado',
  theme_abandoned_mine: 'Mina Abandonada',
  theme_abandoned_mine_desc: 'Horror profundo e escuro de uma mina abandonada',
  theme_gothic_castle: 'Castelo Gótico',
  theme_gothic_castle_desc: 'Horror aristocrático elegante e sombrio',
  theme_underground_bunker: 'Bunker Subterrâneo',
  theme_underground_bunker_desc: 'Experimentos e conspirações no subterrâneo',
  theme_cursed_forest: 'Floresta Maldita',
  theme_cursed_forest_desc: 'Espíritos da natureza e horror primitivo',

  synergy_active_count: '{n} Sinergias Ativas',
  synergy_popup_title: 'Sinergias Ativas',
  syn_fx_dark_mirror_e1: 'Ilusao do Espelho',
  syn_fx_dark_mirror_e2: 'Maldicao do Duplo',
  syn_fx_underground_horror_e1: 'Grito da Masmorra',
  syn_fx_underground_horror_e2: 'Eco da Morte',
  syn_fx_restless_spirits_e1: 'Suspiro dos Mortos',
  syn_fx_restless_spirits_e2: 'Procissao Fantasma',
  syn_fx_creepy_collection_e1: 'Maldicao das Bonecas',
  syn_fx_creepy_collection_e2: 'Labirinto de Espelhos',
  syn_fx_mad_scientist_e1: 'Experiencia Louca',
  syn_fx_mad_scientist_e2: 'Recompensa Alquimica',
  syn_fx_hidden_paths_e1: 'Labirinto de Sombras',
  syn_fx_hidden_paths_e2: 'Terror Oculto',
  syn_fx_circus_nightmare_e1: 'Jogo do Palhaco',
  syn_fx_circus_nightmare_e2: 'Pesadelo do Circo',
  syn_fx_ancient_curse_e1: 'Maldicao Antiga',
  syn_fx_ancient_curse_e2: 'Furia da Mumia',
  syn_fx_hidden_treasures_e1: 'Tentacao do Tesouro',
  syn_fx_hidden_treasures_e2: 'Descoberta Subterranea',
  syn_fx_ship_of_doom_e1: 'Canto Funebre do Mar',
  syn_fx_ship_of_doom_e2: 'Castigo de Davy Jones',
  syn_fx_prison_horror_e1: 'Fuga da Prisao',
  syn_fx_prison_horror_e2: 'Correntes de Opressao',
  syn_fx_deep_descent_e1: 'Brilho Cristalino',
  syn_fx_deep_descent_e2: 'Misterio Subterraneo',
  syn_fx_boom_scare_e1: 'Esteira de Explosao',
  syn_fx_boom_scare_e2: 'Explosao em Cadeia',
  syn_fx_royal_terror_e1: 'Ira do Rei',
  syn_fx_royal_terror_e2: 'Tesouro Real',
  syn_fx_noble_cellar_e1: 'Aroma Envelhecido',
  syn_fx_noble_cellar_e2: 'Adega Secreta',
  syn_fx_quarantine_protocol_e1: 'Alerta de Quarentena',
  syn_fx_quarantine_protocol_e2: 'Ameaca Biologica',
  syn_fx_nature_wrath_e1: 'Neblina da Bruxa',
  syn_fx_nature_wrath_e2: 'Furia Natural',
  syn_fx_ancient_power_e1: 'Forca Ancestral',
  syn_fx_ancient_power_e2: 'Ruinas Misticas',
  syn_fx_echo_chamber_e1: 'Maldicao do Eco',
  syn_fx_echo_chamber_e2: 'Ilusao Sonora',
  syn_fx_water_horror_e1: 'Terror do Abismo',
  syn_fx_water_horror_e2: 'Sussurro da Agua',
  syn_fx_full_course_e1: 'Banquete Completo',
  syn_fx_full_course_e2: 'Sorriso de Satisfacao',
  synergy_dark_mirror: 'Espelho Sombrio',
  synergy_dark_mirror_desc: 'Corredor Escuro + Sala dos Espelhos: Atmosfera +15%, Medo +10%',
  synergy_underground_horror: 'Horror Subterraneo',
  synergy_underground_horror_desc: 'Masmorra/Caixao: Medo +20%, Emocao +10%',
  synergy_restless_spirits: 'Espritos Inquietos',
  synergy_restless_spirits_desc: 'Cemiterio/Caixao/Necroterio: Atmosfera +20%, Visitantes +10%',
  synergy_creepy_collection: 'Colecao Assustadora',
  synergy_creepy_collection_desc: 'Boneca/Espelho/Funhouse: Medo +15%, Emocao +10%',
  synergy_mad_scientist: 'Cientista Louco',
  synergy_mad_scientist_desc: 'Lab/Salao/Ciencia: Emocao +20%, SP +15%',
  synergy_hidden_paths: 'Caminhos Ocultos',
  synergy_hidden_paths_desc: 'Passagem Secreta/Corredor/Sotao: Atmosfera +15%, Corrente +20%',
  synergy_circus_nightmare: 'Pesadelo do Circo',
  synergy_circus_nightmare_desc: 'Funhouse/Aberracoes/Trapezio: Diversao +20%, Medo +15%',
  synergy_ancient_curse: 'Maldicao Antiga',
  synergy_ancient_curse_desc: 'Altar/Maldicao/Mumia: Medo +25%, Emocao +15%',
  synergy_hidden_treasures: 'Tesouros Ocultos',
  synergy_hidden_treasures_desc: 'Cofre + Rio Subterraneo: SP +20%, Visitantes +10%',
  synergy_ship_of_doom: 'Navio da Morte',
  synergy_ship_of_doom_desc: 'Capitao/Carga/Davy: Atmosfera +15%, Medo +15%',
  synergy_prison_horror: 'Horror Prisional',
  synergy_prison_horror_desc: 'Brig + Davy: Emocao +20%, Ameaca +10%',
  synergy_deep_descent: 'Descida Profunda',
  synergy_deep_descent_desc: 'Mina/Cristal/Lago: Atmosfera +20%, Visitantes +15%',
  synergy_boom_scare: 'Susto Explosivo',
  synergy_boom_scare_desc: 'Explosivos + Tunel: Emocao +25%, Corrente +15%',
  synergy_royal_terror: 'Terror Real',
  synergy_royal_terror_desc: 'Trono/Torre/Vinho: Medo +15%, SP +20%',
  synergy_noble_cellar: 'Adega Nobre',
  synergy_noble_cellar_desc: 'Adega + Passagem: Atmosfera +15%, SP +10%',
  synergy_quarantine_protocol: 'Protocolo de Quarentena',
  synergy_quarantine_protocol_desc: 'Servidor/Quarentena/Arsmaz: Emocao +20%, Medo +10%',
  synergy_nature_wrath: 'Furia da Natureza',
  synergy_nature_wrath_desc: 'Bruxa/Pantano/Fada: Atmosfera +20%, Ameaca +10%',
  synergy_ancient_power: 'Poder Antigo',
  synergy_ancient_power_desc: 'Ruinas/Fada/Altar: Medo +20%, Visitantes +15%',
  synergy_echo_chamber: 'Camara de Eco',
  synergy_echo_chamber_desc: 'Musica/Biblioteca/Corredor: Corrente +25%, Atmosfera +10%',
  synergy_water_horror: 'Horror Aquatico',
  synergy_water_horror_desc: 'Banheiro/Rio/Lago: Medo +15%, Atmosfera +15%',
  synergy_full_course: 'Cardapio Completo',
  synergy_full_course_desc: 'Cozinha/Banheiro/Musica: Diversao +25%, Visitantes +20%',
};

export default ptBR;
